module.exports = __webpack_public_path__ + "static/media/loader.3bae0791.gif";